
<div class="region-select">
  <div class="modal region-select-modal">
    <div class="modal-background" @click="closeModal"></div>
    <div class="modal-card">
      <section class="modal-card-body">
        <p class="subtitle">
          {{ $t("gps.where-are-you") }}
        </p>
        <div class="geo">
          <div v-if="!country" class="country">
            <div @click="country = 'Thailand'" style="margin-bottom: 10px">
              <p class="has-text-dark">{{ translateGeo("Thailand") }}</p>
              <!-- <flag iso="th" :squared="false" /> -->
            </div>
            <div @click="country = 'Myanmar'" style="margin-bottom: 10px">
              <p class="has-text-dark">{{ translateGeo("Myanmar") }}</p>
              <!-- <flag iso="mm" :squared="false" /> -->
            </div>
            <div @click="country = 'Portugal'">
              <p class="has-text-dark">{{ translateGeo("Portugal") }}</p>
              <!-- <flag iso="pt" :squared="false" /> -->
            </div>
          </div>
          <div v-else>
            <div
              @click="resetCountry"
              style="margin-bottom: 10px; font-size: 1.3em"
            >
              <div style="float: left; width: 0; margin-top: 16px">
                <span class="button is-light" style="padding: 12px">
                  <i class="fa fa-chevron-left fa-lg has-text-grey" />
                </span>
              </div>
              <!-- <flag v-if="country === 'Thailand'" iso="th" :squared="false" /> -->
              <!-- <flag v-if="country === 'Myanmar'" iso="mm" :squared="false" /> -->
              <!-- <flag v-if="country === 'Portugal'" iso="pt" :squared="false" /> -->
            </div>
            <div v-for="c in cities" :key="c" class="cities">
              <span class="button" @click="chooseCity(c)">{{
                translateGeo(c)
              }}</span>
            </div>
          </div>
        </div>
        <br />
        <p v-if="unknownGPSLocation" class="has-text-grey">
          <i class="fa fa-spinner fa-spin" />
          &nbsp;{{ $t("gps.detecting-gps") }}
        </p>
        <p v-else @click="useDetectedRegion">
          <span class="button is-white">{{ $t("gps.gps-detected") }}</span>
          <span class="button is-link is-outlined">{{
            translateGeo(detectedRegion)
          }}</span>
        </p>
      </section>
    </div>
    <button
      class="modal-close is-large"
      aria-label="close"
      @click="closeModal"
    ></button>
  </div>
</div>
